import React from "react";
import { Box, Flex } from "rebass/styled-components";

import { testimonialQuote } from "../../../constants/constants";
import { ContentSize, DynamicTestimonialContent, DynamicCardStyle, IconPack } from "../../models/app-data-model";
import { addTitleToInlineSvg, sanitizeRichText } from "../../services/string-manipulation/string-manipulation-service";
import "./testimonial-card.scss";

export type TestimonialCardProps = {
  card_style: DynamicCardStyle;
  card_width?: number;
  card_content: DynamicTestimonialContent;
  card_content_size: ContentSize;
};

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  card_style,
  card_width,
  card_content,
  card_content_size }: TestimonialCardProps) => {
  const cardClasses = `content-card grid-card ${card_width === 4 ? 'quarter-width' : card_width === 3 ? 'third-width' : card_width === 2 ? 'half-width' : 'full-width'
    }`;

  return (
    <div
      className={`${card_style}-testimonial-card ${cardClasses} ${card_content_size.toLocaleLowerCase()}-content-size`}
      flexDirection="column"
      justifyContent="space-between"
    >
      <div className="quote-and-body">
        <span
        className="testimonial-quote-icon"
        ></span>
        
        <div className="testimonial-body xl" dangerouslySetInnerHTML={{ __html: sanitizeRichText(card_content?.testimonial_body) }} />
      </div>
      <Flex className="author-section">
        <img className="author-image" src={card_content?.author_image?.url} alt={card_content?.image_alt_text} />
        <div className="text-area">
          <span className="large-text author-name ">{card_content?.author_name}</span>
          <span className="medium-text description">{card_content?.description}</span>
        </div>
      </Flex>
    </div>
  );
};

export default TestimonialCard;
